/* Built In Imports */
import { Box, Grid, Image, Link, Text } from '@chakra-ui/react';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import config from '@config';

/**
 * @description Renders the SadhanaModule component
 * @param {Array} moduleData - data
 * @returns {ReactElement} SadhanaModule component
 */
const SadhanaModule = ({ moduleData }) => {
  return (
    <Box
      bgGradient="linear(180deg, #FFEAB4 0%, #FFF7E2 100%);)"
      padding={{ base: '40px 20px', md: '70px 20px' }}
    >
      <Box
        maxWidth={{ base: '', md: '998px', lg: '1120px' }}
        fontFamily="FedraSansStd-A-medium"
        mx="auto"
      >
        <Text
          fontSize={{ base: '16px', md: '22px' }}
          color="#705D2B"
          textAlign="center"
          fontFamily="FedraSansStd-book"
        >
          {moduleData[0].title[0].titleText}
        </Text>
        <Text
          fontSize={{ base: '27px', md: '40px' }}
          textAlign="center"
          mb={{ base: '25px', md: '50px' }}
        >
          {moduleData[0].title[0].titleSubtext}
        </Text>
        <Grid
          templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
          gap="20px"
        >
          {moduleData[0]?.simpleCards.map((data, i) => {
            return (
              <Box m="0 10px" key={i} className="descripText">
                <Image
                  src={data.rectangularImage.url}
                  alt={data.rectangularImage.alt}
                  title={data.rectangularImage.title}
                  mb={{ base: '20px', md: '50px' }}
                  height={{ base: '200px', md: 'auto' }}
                  width="100%"
                  borderRadius={{ base: '6px', md: '12px' }}
                  minH="200px"
                />
                <Text fontSize={{ base: '24px', md: '27px' }} mb="20px">
                  {data.title}
                </Text>
                <Text
                  color="#28231E"
                  fontSize="16px"
                  fontFamily="FedraSansStd-book"
                >
                  {parser(data.descriptionText)}
                </Text>
              </Box>
            );
          })}
        </Grid>
      </Box>

      {moduleData[2]?.linkUrl != '' && (
        <Box
          maxWidth={{ base: '', md: '998px', lg: '1120px' }}
          fontFamily="FedraSansStd-A-medium"
          m="50px auto"
          bgColor="#fff"
          p="30px"
          borderRadius="11px"
          boxShadow="0px 20px 20px rgba(0, 0, 0, 0.07)"
          display={{ base: 'block', md: 'flex' }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display={{ base: 'block', md: 'flex' }} alignItems="center" textAlign={{ base:'center', md:'left'}}>
            <Image
              src={`${config.imgPath}/d/46272/1643276421-yantra_icon.png`}
              alt=""
              title=""
              mb={{ base: '30px', md: '0' }}
            />
            <Text
              ml={{ base: '0', md: '40px' }}
              fontFamily="FedraSansStd-medium"
              className="yantra-structure m-0" textAlign="left"
            >
              {StructuredTextContent(moduleData[1]?.body)}
            </Text>
          </Box>
          {/* {moduleData[2]?.linkUrl != '' && (
            <> */}
          <Link
            mt={{ base: '30px', md: '0' }}
            href={moduleData[2]?.linkUrl}
            bgColor="#FFCB12"
            color="#28231E"
            padding="10px 30px"
            borderRadius="5px"
            display="inline-block"
            fontFamily="FedraSansStd-medium"
            _hover={{
              bgColor: '#FFCB12',
              textDecoration: 'none',
            }}
            _focus={{
              bgColor: '#FFCB12',
              textDecoration: 'none',
            }}
            _active={{
              bgColor: '#FFCB12',
              textDecoration: 'none',
            }}
          >
            {moduleData[2]?.buttonText}
          </Link>
          {/* </>
          )} */}
        </Box>
      )}
      <style jsx global>
        {`
          .descripText ul {
            margin-left: 28px;
            padding: 10px 0;
          }
          .descripText ul li {
            padding: 5px 0;
          }
        `}
      </style>
    </Box>
  );
};

export default SadhanaModule;
